import React from 'react';

export default function TestPrepInfo({ userType }) {
	if (userType === 'prc') {
		return (
			<p>
				Certain medications, supplements, and/or foods may impact test results. Ask your doctor if it is
				necessary to discontinue medications or supplements prior to testing. More information about
				interactions and test prep{' '}
				<a href="https://www.gdx.net/tests/prep" target="_blank" rel="noopener noreferrer">
					can be found here <span className="fa fa-external-link"></span>
				</a>
				.
			</p>
		);
	}

	return (
		<p>
			Healthcare providers may choose for patients to discontinue non-essential medications and nutritional
			supplements to get a baseline reading or continue them to assess the efficacy of treatments. Test prep and
			clinical considerations{' '}
			<a href="https://www.gdx.net/tests/prep" target="_blank" rel="noopener noreferrer">
				can be found here <span className="fa fa-external-link"></span>
			</a>
			.
		</p>
	);
}
